import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Painting_work_for_the_purpose_of_sealing() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>       עבודות צביעה למטרת איטום </h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Painting_work_for_the_purpose_of_sealing">     עבודות צביעה למטרת איטום </Link>{" "}
</div>
    </div>
        <div className="video-line" />
<div className="video-box2">
  <iframe
    width="100%"
    height="400"
    src="https://www.youtube.com/embed/oHQ0qjxyirI?start=11"
    title="YouTube video"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>
</div>
      {/* CONTENT */}
<div className="page6">
  <div className="container">
            <div className="red-banner">
עבודות צביעה למטרת איטום וצביעה בגבהים  </div>
    <div className="content-row2">



      <div className="text-box">


  <h2 className="info-title">   אנו באיטומים בגבהים מבצעים עבודות צביעה, עבודות שיקום, ועבודות צבע לאסטטיקה  ע"י חומרי איטום אקריליים לקירות חיצוניים.

</h2>


  <h2 className="info-title">   העבודה מתבצעת באמצעות:



</h2>
  <ul className="info-list">
    <li> סנפלינג</li>
    <li>במות הרמה</li>
    <li> מנוף סל</li>
      <li>   פיגומים </li>
    <li>הרחקת יונים</li>
    <li>ועוד</li>
  </ul>


  <h2 className="info-title">   ע"י צוות שמוכשר ומאושר לכך ע"י משרד העבודה.





</h2>




      </div>

    </div>




    <ContactSection2/>
<div className="links2">


  <Link to="/Sealing_Wet_Rooms" className="link-right" > קידוחי יהלום</Link>
  <Link to="/Waterproofing_roofs_with_PVC_sheets" className="link-left" >   איטום גגות ע"י יריעות P.V.C </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


